import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";

import {Alert, Button, Card, CardBody, Col, Container, InputGroup, Label, Row} from "reactstrap";

//redux
import {useDispatch, useSelector} from "react-redux";
import withRouter from "components/Common/withRouter";

// actions
import {postServiceOnboarding} from "../../store/actions";

// import images

const ServiceOnboarding = props => {

  //meta title
  document.title = "Service Onboarding | Temperstack";

  const dispatch = useDispatch()

  const [allServices, setAllServices] = useState([
    {name: "", description: ""},
  ]);

  useEffect(() => {
  });


  const {error} = useSelector(state => ({
    error: state.Login.error,
  }));

  const handleFormChange = (index, event) => {
    let data = [...allServices];
    data[index][event.target.name] = event.target.value;
    setAllServices(data);
  }

  const addFields = () => {
    let newfield = {name: '', description: ''}
    setAllServices([...allServices, newfield])
  }

  const removeFields = (index) => {
    let data = [...allServices];
    data.splice(index, 1)
    setAllServices(data)
  }

  const submit = (e) => {
    e.preventDefault();
    dispatch(postServiceOnboarding({'services': allServices}, props.router.navigate));
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={12} lg={10} xl={10}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Please add services to continue</h5>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2">
                    {error ? <Alert color="danger">{error}</Alert> : null}
                    {
                      allServices.map((input, index) => {
                        return (
                          <div key={index} className="row gy-2 gx-3 mt-3 align-items-center">
                            <div className="col-sm-auto">
                              <Label className="visually-hidden" htmlFor="autoSizingInputGroup">Name</Label>
                              <InputGroup>
                                <input
                                  type="text"
                                  name="name"
                                  value={input.name}
                                  className="form-control"
                                  id="autoSizingInputGroup"
                                  placeholder="Name"
                                  onChange={event => handleFormChange(index, event)}
                                />
                              </InputGroup>
                            </div>
                            <div className="col-sm-auto">
                              <Label className="visually-hidden" htmlFor="autoSizingInputGroup">Description</Label>
                              <InputGroup>
                                <input
                                  type="text"
                                  name="description"
                                  className="form-control"
                                  id="autoSizingInputGroup"
                                  placeholder="Description"
                                  value={input.description}
                                  onChange={event => handleFormChange(index, event)}
                                />
                              </InputGroup>
                            </div>
                            <div className="col-sm-auto">
                              <Button
                                color="danger"
                                className="btn btn-danger waves-effect waves-light"
                                onClick={() => removeFields(index)}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        )
                      })
                    }


                    <div className="mt-3 d-grid d-flex flex-wrap gap-2 bx-pull-right">
                      <div className="col-sm-auto">
                        <button
                          className="btn btn-primary btn-block"
                          onClick={addFields}
                        >
                          Add More
                        </button>
                      </div>
                      <div className="col-sm-auto">
                        <button
                          className="btn btn-success btn-block"
                          onClick={submit}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ServiceOnboarding);

ServiceOnboarding.propTypes = {
  history: PropTypes.object,
};
